module.exports = __webpack_public_path__ + "img/root0.141970bf.png";